import { SidebarConfig } from '@/config/sidebar.config';
import { OwnerPermissionsResponseDto } from '@/features/owners/types/owners-dto';
import { SidebarButtons, SidebarElement } from '@/components/everridge/sidebar/types';

const filterSidebarSections = (
	sections: SidebarElement,
	permissions?: OwnerPermissionsResponseDto,
): SidebarElement =>
	Object.fromEntries(
		Object.entries(sections).map(([title, element]) => {
			const filteredElementItems = element.items?.filter((item) =>
				item.enabled(permissions),
			);

			return [
				title,
				{
					title: element.title,
					items: filteredElementItems,
				},
			];
		}),
	);

const getFilteredOwners = (
	sidebar: SidebarConfig,
	permissions?: OwnerPermissionsResponseDto,
): SidebarElement => filterSidebarSections(sidebar.Owner, permissions);

const getFilteredAdmin = (sidebar: SidebarConfig): SidebarElement =>
	filterSidebarSections(sidebar.Admin);

const setSidebarTab = (url: string, setTab: (tab: SidebarButtons) => void) => {
	switch (url) {
		case 'dashboard':
			return setTab(SidebarButtons.Dashboard);
		case 'apartments':
			return setTab(SidebarButtons.Apartments);
		case 'calendar':
			return setTab(SidebarButtons.Calendar);
		case 'finances':
			return setTab(SidebarButtons.Finances);
		case 'orders':
			return setTab(SidebarButtons.Orders);
		case 'faqs':
			return setTab(SidebarButtons.Faq);
		case 'owners':
			return setTab(SidebarButtons.Owners);
		case 'notifications':
			return setTab(SidebarButtons.Notifications);
		case 'news-and-offers':
			return setTab(SidebarButtons.NewsOffers);
		case 'settings':
			return setTab(SidebarButtons.Settings);
		case 'tenants':
			return setTab(SidebarButtons.Tenants);
		case 'users':
			return setTab(SidebarButtons.Users);
		case 'user-activities':
			return setTab(SidebarButtons.UserActivities);
		case 'releases':
			return setTab(SidebarButtons.Releases);
		case 'data':
			return setTab(SidebarButtons.Data);
		default:
			return setTab(SidebarButtons.Dashboard);
	}
};

export const SidebarHelper = {
	getFilteredOwners,
	getFilteredAdmin,
	setSidebarTab,
};
